import React, { useState } from 'react';
import { PaystackPayment } from './PaystackPayment';
interface LifetimePartnerFormProps {
  onSuccess?: (reference: string) => void;
}
export const LifetimePartnerForm: React.FC<LifetimePartnerFormProps> = ({
  onSuccess
}) => {
  const [formData, setFormData] = useState({
    email: '',
    fullName: '',
    sex: '',
    phone: '',
    location: '',
    industry: '',
    occupation: '',
    commitment: '',
    mediaConsent: '',
    comments: ''
  });
  const [isFormComplete, setIsFormComplete] = useState(false);
  const handleChange = e => {
    const {
      name,
      value,
      type,
      checked
    } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: type === 'checkbox' ? checked : value
    }));
    // Check if required fields are complete
    setTimeout(() => {
      const requiredFields = ['email', 'fullName', 'sex', 'phone', 'location', 'industry', 'occupation', 'commitment', 'mediaConsent'];
      const isComplete = requiredFields.every(field => formData[field]);
      setIsFormComplete(isComplete && formData.email.includes('@'));
    }, 100);
  };
  return <div className="w-full max-w-lg mx-auto" data-id="element-902">
      <div className="mb-6" data-id="element-903">
        <h2 className="text-xl font-bold text-gray-800 mb-4" data-id="element-904">
          Lifetime Partner Access
        </h2>
        <p className="text-gray-600 mb-4" data-id="element-905">
          Join The Networking Salon as a Lifetime Partner for ₦50,000
          (Discounted from ₦100,000)
        </p>
      </div>
      <div className="space-y-4 mb-6" data-id="element-906">
        <div data-id="element-907">
          <label htmlFor="email" className="block text-sm font-medium text-gray-700 mb-1" data-id="element-908">
            Email <span className="text-gray-500" data-id="element-909">(required)</span>
          </label>
          <input type="email" id="email" name="email" value={formData.email} onChange={handleChange} className="w-full p-2 border border-gray-300 rounded-md" placeholder="Enter your email address" required data-id="element-910" />
        </div>
        <div data-id="element-911">
          <label htmlFor="fullName" className="block text-sm font-medium text-gray-700 mb-1" data-id="element-912">
            Full Name <span className="text-gray-500" data-id="element-913">(required)</span>
          </label>
          <input type="text" id="fullName" name="fullName" value={formData.fullName} onChange={handleChange} className="w-full p-2 border border-gray-300 rounded-md" placeholder="Enter your full name" required data-id="element-914" />
        </div>
        <div data-id="element-915">
          <label className="block text-sm font-medium text-gray-700 mb-1" data-id="element-916">
            Sex <span className="text-gray-500" data-id="element-917">(required)</span>
          </label>
          <div className="space-y-2" data-id="element-918">
            {['Male', 'Female'].map(option => <div key={option} className="flex items-center" data-id="element-919">
                <input type="radio" id={`sex-${option}`} name="sex" value={option} checked={formData.sex === option} onChange={handleChange} required className="mr-2 h-4 w-4 border-2 border-gray-300" data-id="element-920" />
                <label htmlFor={`sex-${option}`} className="text-gray-700" data-id="element-921">
                  {option}
                </label>
              </div>)}
          </div>
        </div>
        <div data-id="element-922">
          <label htmlFor="phone" className="block text-sm font-medium text-gray-700 mb-1" data-id="element-923">
            Phone Number <span className="text-gray-500" data-id="element-924">(required)</span>
          </label>
          <input type="tel" id="phone" name="phone" value={formData.phone} onChange={handleChange} className="w-full p-2 border border-gray-300 rounded-md" placeholder="Enter your phone number" required data-id="element-925" />
        </div>
        <div data-id="element-926">
          <label htmlFor="location" className="block text-sm font-medium text-gray-700 mb-1" data-id="element-927">
            City of Residence <span className="text-gray-500" data-id="element-928">(required)</span>
          </label>
          <select id="location" name="location" value={formData.location} onChange={handleChange} required className="w-full p-2 border border-gray-300 rounded-md" data-id="element-929">
            <option value="" data-id="element-930">Select your city</option>
            <option value="Houston Texas" data-id="element-931">Houston Texas</option>
            <option value="Lagos" data-id="element-932">Lagos</option>
            <option value="Abuja" data-id="element-933">Abuja</option>
            <option value="Benin City" data-id="element-934">Benin City</option>
            <option value="Warri" data-id="element-935">Warri</option>
            <option value="Berlin" data-id="element-936">Berlin</option>
            <option value="Port Harcourt" data-id="element-937">Port Harcourt</option>
            <option value="UK" data-id="element-938">UK</option>
            <option value="Other" data-id="element-939">Other</option>
          </select>
        </div>
        <div data-id="element-940">
          <label htmlFor="industry" className="block text-sm font-medium text-gray-700 mb-1" data-id="element-941">
            Industry <span className="text-gray-500" data-id="element-942">(required)</span>
          </label>
          <input type="text" id="industry" name="industry" value={formData.industry} onChange={handleChange} className="w-full p-2 border border-gray-300 rounded-md" placeholder="Enter your industry" required data-id="element-943" />
        </div>
        <div data-id="element-944">
          <label htmlFor="occupation" className="block text-sm font-medium text-gray-700 mb-1" data-id="element-945">
            What do you do? <span className="text-gray-500" data-id="element-946">(required)</span>
          </label>
          <textarea id="occupation" name="occupation" value={formData.occupation} onChange={handleChange} rows={3} className="w-full p-2 border border-gray-300 rounded-md" placeholder="Describe your occupation or role" required data-id="element-947" />
        </div>
        <div data-id="element-948">
          <label className="block text-sm font-medium text-gray-700 mb-1" data-id="element-949">
            Are you committed to actively participating in the ways described
            above? <span className="text-gray-500" data-id="element-950">(required)</span>
          </label>
          <div className="space-y-2" data-id="element-951">
            {['Yes', 'No', 'I have questions'].map(option => <div key={option} className="flex items-center" data-id="element-952">
                <input type="radio" id={`commitment-${option}`} name="commitment" value={option} checked={formData.commitment === option} onChange={handleChange} required className="mr-2 h-4 w-4 border-2 border-gray-300" data-id="element-953" />
                <label htmlFor={`commitment-${option}`} className="text-gray-700" data-id="element-954">
                  {option}
                </label>
              </div>)}
          </div>
        </div>
        <div data-id="element-955">
          <label className="block text-sm font-medium text-gray-700 mb-1" data-id="element-956">
            Are you okay with your pictures and videos of you taken at our
            events (in-person or online) be used for promotional purposes?{' '}
            <span className="text-gray-500" data-id="element-957">(required)</span>
          </label>
          <div className="space-y-2" data-id="element-958">
            {['Yes', 'No'].map(option => <div key={option} className="flex items-center" data-id="element-959">
                <input type="radio" id={`mediaConsent-${option}`} name="mediaConsent" value={option} checked={formData.mediaConsent === option} onChange={handleChange} required className="mr-2 h-4 w-4 border-2 border-gray-300" data-id="element-960" />
                <label htmlFor={`mediaConsent-${option}`} className="text-gray-700" data-id="element-961">
                  {option}
                </label>
              </div>)}
          </div>
        </div>
        <div data-id="element-962">
          <label htmlFor="comments" className="block text-sm font-medium text-gray-700 mb-1" data-id="element-963">
            Additional Comments or Suggestions (You can ask your questions
            here): <span className="text-gray-500" data-id="element-964">(optional)</span>
          </label>
          <textarea id="comments" name="comments" value={formData.comments} onChange={handleChange} rows={3} className="w-full p-2 border border-gray-300 rounded-md" placeholder="Enter any additional comments or questions" data-id="element-965" />
        </div>
      </div>
      {isFormComplete ? <PaystackPayment amount={50000} email={formData.email} name={formData.fullName} phone={formData.phone} onSuccess={onSuccess} metadata={{
      ...formData
    }} data-id="element-966" /> : <button disabled className="w-full py-2 px-4 bg-gray-300 text-gray-500 rounded-md cursor-not-allowed" data-id="element-967">
          Complete all required fields to proceed
        </button>}
    </div>;
};